import {CurrencyExchange, QueryCurrencyExchangeArgs} from "@irati/types"
import {createUseQuery} from "@irati/utils/services/apollo"
import {useTopupCurrencyQuery} from "@irati/wallet/hooks/wallet"
import CashbackForCurrencyQuery, {cashbackForCurrencyKey} from "../services/queries/cashbackForCurrency"

export const useCurrencyExchangeQuery = createUseQuery<CurrencyExchange, QueryCurrencyExchangeArgs>(CashbackForCurrencyQuery, {
  key: cashbackForCurrencyKey
})
export const useTenantCurrencyExchangeQuery = () => {
  const {data: tenantCurrency} = useTopupCurrencyQuery(null)
  const {data: currencyExchange} = useCurrencyExchangeQuery(
    {
      currency: tenantCurrency
    },
    {
      skip: !tenantCurrency
    }
  )
  return {tenantCurrency, currencyExchange}
}
